import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Base64ToImageComponent } from './base64-to-image/base64-to-image.component';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [Base64ToImageComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AppMaterialModule
  ],
  exports: [Base64ToImageComponent]
})
export class DisplayBase64ImageModule { }
